import { Briefcase, Plus } from 'lucide-react';

/**
 * Empty state for the private-events list (BON-518).
 *
 * The copy matters more than it looks. A region with no private events is the
 * NORMAL case — most regions run fewer than ten a month — so this has to read
 * as "nothing scheduled", not as a failure or an empty search. Saying so
 * outright is what stops an RD wondering whether the page is broken.
 */
export default function PrivateEventsEmpty({
  tab,
  onCreate,
}: {
  tab: 'upcoming' | 'past';
  onCreate?: () => void;
}) {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        padding: 32,
        textAlign: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 44,
          height: 44,
          borderRadius: 'var(--nb-radius-card)',
          border: '1px dashed var(--nb-border-2)',
          background: 'var(--nb-surface)',
          color: 'var(--nb-faint)',
        }}
      >
        <Briefcase size={20} />
      </div>
      <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: 'var(--nb-ink)' }}>
        {tab === 'upcoming' ? 'No private events coming up' : 'No past private events'}
      </p>
      <p
        style={{
          margin: 0,
          maxWidth: 320,
          fontSize: 12,
          lineHeight: 1.6,
          color: 'var(--nb-subtle)',
        }}
      >
        {tab === 'upcoming'
          ? 'That’s normal — many regions run a private event only every few weeks. When a deposit lands, create the event here.'
          : 'Private events you have run will appear here once they are past.'}
      </p>
      {tab === 'upcoming' && onCreate && (
        <button
          type="button"
          onClick={onCreate}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            marginTop: 4,
            padding: '7px 13px',
            borderRadius: 'var(--nb-radius-btn)',
            background: 'var(--nb-primary)',
            color: 'var(--nb-on-primary)',
            fontSize: 12,
            fontWeight: 700,
          }}
        >
          <Plus size={14} /> New private event
        </button>
      )}
    </div>
  );
}
